// Leaflet CSS — must come before any map initialization
import 'leaflet/dist/leaflet.css'
import 'leaflet-easybutton/src/easy-button.css'
import 'leaflet.fullscreen/Control.FullScreen.css'
import 'leaflet-geosearch/dist/geosearch.css'

// App styles (overrides go after Leaflet's CSS)
import './style.css'

import { initMap } from './map'

// initMap is async because plugin imports are dynamic (see map.ts)
await initMap()